
import styled from "styled-components";
import {fmoney} from '../../../../utils/utils'
export default function ClaimConfrim({amount,time,intl}) {

  return (
    <Wrapper>
      <Text>
        <span>{time}</span> {
        intl.formatMessage({
          id: "pages.account.profit_harvest_tip1",
          defaultMessage: "共产生收益",
        })}
      </Text>
      <Squre>
        <img src="/image/Rb.png" alt=""></img>
        <p>{fmoney(amount,2)}</p>
      </Squre>
      <Text>{
       intl.formatMessage({
        id: "pages.account.profit_harvest_tip2",
        defaultMessage: "是否收获？",
      })}</Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
`;

const Text = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.6rem;
  color: #000;
  span {
    color: #ff5c00;
  }
`;

const Squre = styled.div`
  background: #f4f5f6;
  border-radius: 1.6rem;

  width: 8.6rem;
  height: 8.6rem;
  margin: 2.0rem auto;
  padding: 1.5rem 1.6rem;
  box-sizing: border-box;
  img {
    width: 2.6rem;
  }
  p {
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.0rem;
    color: #000000;

    margin-top: .5rem;
  }
`;
